export default __webpack_public_path__ + "files/b0fc881c4a499094c4858cbbd547f1d1.webp";